import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Spin, Tag, message } from 'antd';
import {
  ArrowLeftOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import PortalLayout from '../../components/portal';
import Rule from '../GameDetail/rule';
import { post } from '../../commons/http';
import styles from './style.less';

/**
 * 官网公开赛事详情：未登录可查看赛事基本信息与竞赛规则；
 * 点击“报名参赛”时未登录则引导去登录/注册。
 */
export default class PortalGameDetail extends Component {
  state = {
    competition: null,
    loading: true,
  };

  componentDidMount() {
    this.fetchDetail();
  }

  fetchDetail = async () => {
    try {
      const response = await post('/competition/find', {
        competitionId: this.props.match.params.id,
      });
      if (response.code === 0) {
        this.setState({ competition: response.data.competition, loading: false });
      } else {
        message.error(response.msg || '赛事不存在', 2);
        this.setState({ loading: false });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  handleSignUpClick = () => {
    const user = window.localStorage.getItem('user');
    if (user) {
      // 已登录直接进入登录态详情页报名
      this.props.history.push(
        `/home/game-detail/${this.props.match.params.id}/rule`
      );
    } else {
      message.info('请先登录后再报名参赛', 2);
      this.props.history.push('/login');
    }
  };

  renderStatus(status) {
    const map = {
      0: { text: '未开始', cls: styles.before },
      1: { text: '报名进行中', cls: styles.active },
      2: { text: '已结束', cls: styles.after },
    };
    const s = map[status] || map[0];
    return <span className={`${styles.status} ${s.cls}`}>{s.text}</span>;
  }

  render() {
    const { competition, loading } = this.state;

    return (
      <PortalLayout>
        <div className={styles.container}>
          <Link to="/portal/competition" className={styles.back}>
            <ArrowLeftOutlined /> 返回赛事中心
          </Link>

          {loading ? (
            <div className={styles.loading}>
              <Spin size="large" />
            </div>
          ) : !competition ? (
            <div className={styles.empty}>赛事信息加载失败</div>
          ) : (
            <>
              <div className={styles['info-card']}>
                <div className={styles['info-head']}>
                  <div>
                    <h1 className={styles.title}>{competition.title}</h1>
                    <div className={styles.tags}>
                      {(competition.tags || []).map((tag, i) => (
                        <Tag key={i} color="#e3f0fb" style={{ color: '#2f7fc4' }}>
                          {tag}
                        </Tag>
                      ))}
                    </div>
                  </div>
                  {this.renderStatus(competition.status)}
                </div>

                <p className={styles.desc}>{competition.desc}</p>

                <div className={styles.meta}>
                  <div className={styles['meta-item']}>
                    <ClockCircleOutlined />
                    <span className={styles['meta-key']}>报名截止</span>
                    <span>{competition.end_time}</span>
                  </div>
                  <div className={styles['meta-item']}>
                    <TeamOutlined />
                    <span className={styles['meta-key']}>已报名队伍</span>
                    <span>{competition.team_num || 0} 支</span>
                  </div>
                  <div className={styles['meta-item']}>
                    <UserOutlined />
                    <span className={styles['meta-key']}>队伍人数</span>
                    <span>
                      {competition.min_people} - {competition.max_people} 人
                    </span>
                  </div>
                  <div className={styles['meta-item']}>
                    <span className={styles['meta-key']}>主办方</span>
                    <span>{competition.organizer}</span>
                  </div>
                </div>

                <div className={styles['signup-bar']}>
                  <Button
                    type="primary"
                    size="large"
                    className={styles['signup-btn']}
                    onClick={this.handleSignUpClick}
                    disabled={competition.status !== 1}
                  >
                    {competition.status === 1
                      ? '立即报名参赛'
                      : competition.status === 0
                      ? '报名未开始'
                      : '报名已截止'}
                  </Button>
                  <span className={styles['signup-tip']}>
                    报名需登录账号，还没有账号？<Link to="/register">去注册</Link>
                  </span>
                </div>
              </div>

              <div className={styles['rule-card']}>
                <h2 className={styles['rule-title']}>竞赛规则</h2>
                <Rule competition={competition} />
              </div>
            </>
          )}
        </div>
      </PortalLayout>
    );
  }
}
